import { render, staticRenderFns } from "./ChangingOrCancellingAServiceOrNotice.vue?vue&type=template&id=525e786a"
import script from "./ChangingOrCancellingAServiceOrNotice.vue?vue&type=script&lang=ts"
export * from "./ChangingOrCancellingAServiceOrNotice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports